import getRequest from '../../../getRequest';

/**
 * Get user rights mapping from PRISM db.
 *
 * @returns {object}
 */
function getUserPermissions() {
  const endpoint = '/users-management/get-user-permissions/';

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get User Rights')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default getUserPermissions;
